import React, { useMemo } from 'react';
import { Card, CardContent, Typography, Chip, Box } from '@mui/material';
import { GrAction } from 'react-icons/gr';
import { sanitizeHtml } from '../../Utils/text_functions';
import { FaCheck, FaExclamationCircle } from 'react-icons/fa';

const ActionCard = ({ action }) => {


  if (!action || typeof action !== 'object') {
    console.error('Invalid or missing action prop');
    return null;
  }

  // Destructure only the fields we need with fallback values.
  const { 
    start_date_time = null,
    end_date_time = null,
    action_step = 'N/A',
    action_description = 'No description provided.',
    action_class = 'default',
    outputs = ''
  } = action;

  // Map action classes to specific chip details.
  const typeMap = {
    ClarifyingQuestionsAction: {
      label: 'Clarifying Questions',
      icon: <GrAction fontSize="16px" />,
      color: 'primary'
    },
    ReasoningAction: {
      label: 'Reasoning',
      icon: <GrAction fontSize="16px" />,
      color: 'secondary'
    },
    GenerateResponseAction: {
      label: 'Response Generation',
      icon: <GrAction fontSize="16px" />,
      color: 'success'
    },
    ReviewResponseAction: {
      label: 'Review Response',
      icon: <GrAction fontSize="16px" />,
      color: 'info'
    },
    CompletionResponseAction: {
      label: 'Deep Agent Completed',
      icon: <FaCheck  fontSize="16px" />,
      color: 'success'
    },
    ErrorResponseAction: {
      label: 'Deep Agent Error',
      icon: <FaExclamationCircle  fontSize="16px" />,
      color: 'error'
    },
    default: {
      label: 'Action',
      icon: <GrAction fontSize="16px" />,
      color: 'default'
    }
  };

  const actionType = typeMap[action_class] || typeMap.default;

  // Determine content: attempt to parse outputs for a message; otherwise use action_description.
  let content = action_description;


  // Calculate elapsed time between start_date_time and end_date_time.
  let elapsedTime = 'N/A';
  if (start_date_time && end_date_time) {
    try {
      const startTime = new Date(start_date_time);
      const endTime = new Date(end_date_time);
      const elapsedMs = endTime - startTime;
      const seconds = Math.floor(elapsedMs / 1000);
      if (seconds < 60) {
        elapsedTime = `${seconds} sec`;
      } else {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        elapsedTime = `${minutes} min ${remainingSeconds} sec`;
      }
    } catch (error) {
      console.error('Error calculating elapsed time:', error);
    }
  }

  return (
    <Card sx={{ marginBottom: 2, borderRadius: '16px' }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={1}>
          <Chip
            icon={actionType.icon}
            label={actionType.label}
            color={actionType.color}
            variant="outlined"
            size="small"
            sx={{ mr: 1, padding: '5px' }}
          />
        </Box>
        <Typography variant="body2" gutterBottom>
          {sanitizeHtml(content)}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {`Elapsed Time: ${elapsedTime}`}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ActionCard;
